"use client"

import { useEffect } from "react"
import { useParams, useNavigate, Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Box, Typography, Breadcrumbs, Link as MuiLink, CircularProgress } from "@mui/material"
import DashboardLayout from "../components/DashboardLayout"
import CitiesTable from "../components/locations/CitiesTable"
import { getCitiesByState } from "../slices/locationSlice"

const CitiesPage = () => {
  const { stateId } = useParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { cities, state, loading, error } = useSelector((state) => state.locations)

  useEffect(() => {
    if (stateId) {
      dispatch(getCitiesByState(stateId))
    }
  }, [stateId, dispatch])

  if (error) {
    navigate("/locations")
    return null
  }

  return (
    <DashboardLayout>
      <Box sx={{ maxWidth: "1200px", margin: "0 auto" }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
              <MuiLink component={Link} to="/dashboard" color="inherit">
                Dashboard
              </MuiLink>
              <MuiLink component={Link} to="/locations" color="inherit">
                Cities
              </MuiLink>
              <MuiLink component={Link} to="/locations" color="inherit">
                {state?.name}
              </MuiLink>
              <Typography color="text.primary">Cities</Typography>
            </Breadcrumbs>

            <Box sx={{ mb: 4 }}>
              <Typography variant="h4" component="h1" gutterBottom>
                Cities in {state?.name}
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Manage cities for {state?.name} state
              </Typography>
            </Box>

            <CitiesTable cities={cities || []} state={state || {}} />
          </>
        )}
      </Box>
    </DashboardLayout>
  )
}

export default CitiesPage

